import type { DataResponse, ModuleInfo } from '@pms/shared';
import { api } from '@/lib/api';

export const modulesService = {
  async list(): Promise<ModuleInfo[]> {
    const res = await api.get<DataResponse<ModuleInfo[]>>('/modules');
    return res.data.data;
  },
};
